import { render, staticRenderFns } from "./FabNotification.vue?vue&type=template&id=2e2a9328&scoped=true"
import script from "./FabNotification.vue?vue&type=script&lang=js"
export * from "./FabNotification.vue?vue&type=script&lang=js"
import style0 from "./FabNotification.vue?vue&type=style&index=0&id=2e2a9328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a9328",
  null
  
)

export default component.exports